import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { HeaderBasicAuthorizationService } from '../../../../../shared/services/header-basic-authorization.service';
import { ApiEnum } from '../../../../../shared/enums/api.enum';
@Injectable({
  providedIn: 'root'
})
export class JaladorService {

  constructor(
    private http: HttpClient,
    private headerBasicAuthorization: HeaderBasicAuthorizationService
  ) {
  }

  public ListarJaladores() {
    return this.http.get(`${environment.api.WS_HCM.url}/Jalador/ListarJaladores`,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public SaveUpdateJalador(model) {
    return this.http.post(`${environment.api.WS_HCM.url}/Jalador/SaveUpdateJalador`, model,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public ChangeStatusJalador(model) {
    return this.http.post(`${environment.api.WS_HCM.url}/Jalador/ChangeStatusJalador`, model,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public GetReporteJalador(model) {
    return this.http.post(`${environment.api.WS_HCM.url}/Jalador/GetReporteJalador`, model,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }

  public RptPostulanteJalador(model) {
    return this.http.post(`${environment.api.WS_HCM.url}/Jalador/RptPostulanteJalador`, model,
      { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
    .pipe( map( data => data ));
  }
}